import axios from 'axios'

import { AxiosInterceptor } from '../Config/AxiosInterceptor'

AxiosInterceptor()

export type SortOrder = 'ASC' | 'DESC'

export type FinancialTransaction = {
  id: string
  accountId?: string
  customer?: {
    photo?: { url?: string }
    emailAddress?: string
    msisdn?: string
    lastName?: string
    firstName?: string
  }
  type?: string
  amountMajor?: number
  currency?: string
  walletBalanceMajorBefore?: number
  walletBalanceMajorAfter?: number
  metadata?: {
    orderId?: string
    productLeaseId?: string
    tradegridPlusId?: string
    referredUserId?: string
    quoteRequestId?: string
    adminEmail?: string
    transactionNote?: string
    cashbackTier?: string
    rebateAmount?: number
    orderType?: string
    stationLeaseAssetId?: string
    investorLeaseAssetId?: string
    investorTokenAssetId?: string
  }
  paymentProcessor?: string
  paidStatus?: string
  description?: string
  flowType?: 'in' | 'out' | string
  reference?: string
  createdAt?: string
}

const financialTransactionsService = {
  list: async (params: {
    pageNumber: number
    pageSize?: number
    customerAccountId?: string
    customerMsisdn?: string
    sortOrder: SortOrder
    tokenAssetAndBlockchainOnly?: boolean
  }) => {
    const {
      pageNumber,
      pageSize,
      customerAccountId,
      customerMsisdn,
      sortOrder,
      tokenAssetAndBlockchainOnly,
    } = params
    return await axios.get('/financialtransactions', {
      params: {
        pageNumber,
        sortOrder,
        ...(pageSize ? { pageSize } : {}),
        ...(customerAccountId ? { customerAccountId } : {}),
        ...(customerMsisdn ? { customerMsisdn } : {}),
        ...(tokenAssetAndBlockchainOnly ? { tokenAssetAndBlockchainOnly } : {}),
      },
    })
  },
}

export default financialTransactionsService
